"use strict";

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var BASE_CHAT_URI = 'https://aim.twilio.com';
var TYPING_PATH = '/v1/typing';
var TYPING_TIMEOUT = 5;
var HTTP_CACHE_LIFETIME = 'PT5S';
var CONSUMPTION_HORIZON_SENDING_INTERVAL = 'PT5S';
var USER_INFOS_TO_SUBSCRIBE = 100;
var MINIMUM_RETRY_DELAY = 1000;
var MAXIMUM_RETRY_DELAY = 4000;
var MAXIMUM_ATTEMPTS_COUNT = 3;
var RETRY_WHEN_THROTTLED = true;

var Configuration = function () {
    function Configuration(token, options) {
        (0, _classCallCheck3.default)(this, Configuration);

        options = options || {};
        this.options = options.Chat || options.IPMessaging || options || {};
        var baseUrl = this.options.apiUri || this.options.typingUri || BASE_CHAT_URI;
        this.token = token;
        this.baseUrl = baseUrl;
    }

    (0, _createClass3.default)(Configuration, [{
        key: "updateToken",
        value: function updateToken(token) {
            this.token = token;
        }
    }, {
        key: "typingIndicatorUri",
        get: function get() {
            return this.baseUrl + TYPING_PATH;
        }
    }, {
        key: "typingIndicatorTimeoutDefault",
        get: function get() {
            return TYPING_TIMEOUT * 1000;
        }
    }, {
        key: "httpCacheIntervalDefault",
        get: function get() {
            return HTTP_CACHE_LIFETIME;
        }
    }, {
        key: "consumptionReportIntervalDefault",
        get: function get() {
            return CONSUMPTION_HORIZON_SENDING_INTERVAL;
        }
    }, {
        key: "userInfosToSubscribeDefault",
        get: function get() {
            return USER_INFOS_TO_SUBSCRIBE;
        }
    }, {
        key: "backoffConfigDefault",
        get: function get() {
            return {
                min: MINIMUM_RETRY_DELAY,
                max: MAXIMUM_RETRY_DELAY,
                maxAttemptsCount: MAXIMUM_ATTEMPTS_COUNT
            };
        }
    }, {
        key: "backoffConfigOverride",
        get: function get() {
            return this.options.backoffConfigOverride;
        }
    }, {
        key: "retryWhenThrottledDefault",
        get: function get() {
            return RETRY_WHEN_THROTTLED;
        }
    }, {
        key: "retryWhenThrottledOverride",
        get: function get() {
            return this.options.retryWhenThrottledOverride;
        }
    }, {
        key: "typingIndicatorTimeoutOverride",
        get: function get() {
            return this.options.typingIndicatorTimeoutOverride;
        }
    }, {
        key: "httpCacheIntervalOverride",
        get: function get() {
            return this.options.httpCacheIntervalOverride;
        }
    }, {
        key: "consumptionReportIntervalOverride",
        get: function get() {
            return this.options.consumptionReportIntervalOverride;
        }
    }, {
        key: "userInfosToSubscribeOverride",
        get: function get() {
            return this.options.userInfosToSubscribeOverride;
        }
    }]);
    return Configuration;
}();

exports.Configuration = Configuration;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-chat/browser/configuration.js
// module id = ./node_modules/twilio-chat/browser/configuration.js
// module chunks = 0